import { styled } from 'linaria/react';
import { theme } from './theme';
/**
 * Return themed log-method style
 * @param style The style
 * @param type The method
 */

const Themed = (style: string, method: string) => styles[`LOG_${method.toUpperCase()}_${style.toUpperCase()}`] || styles[`LOG_${style.toUpperCase()}`];

const {
  styles
} = theme;
/**
 * console-feed
 */

export const Root = /*#__PURE__*/styled("div")({
  name: "Root",
  class: "ritm362"
});
/**
 * console-message
 */

export const Message = /*#__PURE__*/styled("div")({
  name: "Message",
  class: "m63frxs",
  vars: {
    "m63frxs-0": [props => +/^warn|error$/.test(props.method)],
    "m63frxs-1": [props => Themed('color', props.method)],
    "m63frxs-2": [props => Themed('background', props.method)],
    "m63frxs-3": [props => Themed('border', props.method)]
  }
});
/**
 * message-icon
 */

export const Icon = /*#__PURE__*/styled("div")({
  name: "Icon",
  class: "i1gdymn2",
  vars: {
    "i1gdymn2-0": [props => Themed('icon', props.method)]
  }
});
/**
 * console-content
 */

export const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c19im3td"
});